export default "__VITE_ASSET__B_t96Ec6__"